// extracted by mini-css-extract-plugin
export default {"container":"Bo-z","ratingLayout":"Co-z","ratingLabel":"Do-z","nonInteractiveRatingLabel":"Eo-z"};